export default __webpack_public_path__ + "static/kardo-d58f93369da8d9dc383c8c093dc6ac50.png";